import { render, staticRenderFns } from "./ad-view.vue?vue&type=template&id=3192a1d0"
import script from "./ad-view.vue?vue&type=script&lang=js"
export * from "./ad-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2251928234/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3192a1d0')) {
      api.createRecord('3192a1d0', component.options)
    } else {
      api.reload('3192a1d0', component.options)
    }
    module.hot.accept("./ad-view.vue?vue&type=template&id=3192a1d0", function () {
      api.rerender('3192a1d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ads/ad-view.vue"
export default component.exports